import { Preferences } from "@capacitor/preferences"

/**
 * A half-typed chat message, kept on this device only, per user and conversation
 * (COACHIO-2027). Never sent to the server: chat text is stored encrypted there and a
 * draft does not belong in it. Same key shape as the coach dashboard's localStorage.
 */
const PREFIX = "chat-draft:"

const key = (userId: number, conversationId: number) => `${PREFIX}${userId}:${conversationId}`

export async function loadChatDraft(userId: number, conversationId: number): Promise<string> {
  try {
    const { value } = await Preferences.get({ key: key(userId, conversationId) })
    return value ?? ""
  } catch {
    return ""
  }
}

/** Empty text drops the draft. */
export async function saveChatDraft(userId: number, conversationId: number, text: string): Promise<void> {
  const k = key(userId, conversationId)
  // try/await, not .catch(): a mocked Preferences may return no promise at all.
  try {
    if (text.trim() === "") await Preferences.remove({ key: k })
    else await Preferences.set({ key: k, value: text })
  } catch {
    /* a lost draft is not worth an error */
  }
}

/** Every draft on the device. Called on logout. */
export async function clearChatDrafts(): Promise<void> {
  try {
    const { keys } = await Preferences.keys()
    await Promise.all(keys.filter((k) => k.startsWith(PREFIX)).map((k) => Preferences.remove({ key: k })))
  } catch {
    /* nothing to clear */
  }
}
